module.exports = __webpack_public_path__ + "assets/img/1289c175ed1d48ed2bed62472368b342.png";